import { Outlet } from "react-router-dom";

import { Footer } from "../footer/footer";
import { Navbar } from "../navbar/navbar";

import { AlarmProvider } from "../../../context/alarm/alarm";

export const Layout = () => (
  <AlarmProvider>
    <header className="fixed-top">
      <Navbar />
    </header>
    <main>
      <Outlet />
    </main>
    <Footer />
  </AlarmProvider>
);
